import React, { useEffect, useContext } from 'react';
import { AgendaContext } from '../contexts/AgendaContext';
// Mui components
import { Box, Typography } from '@mui/material';
// Components
import ListadoConsultorios from '../components/MisConsultorios/ListadoConsultorios';
// ErrorProvider
import { useError } from '../contexts/ErrorProvider.jsx';

export default function MisConsultorios() {
  
  const { getSolicitudes, prestadoresOsde } = useContext(AgendaContext);

  const { handleError } = useError();
  
  useEffect(() => {
    const solicitudes = async () => {
      try{
        await getSolicitudes();
      }
      catch (error) {
        handleError({ error: error, description: 'initializeError' });
      } 
    };

    if (prestadoresOsde) solicitudes();
  }, [prestadoresOsde]);

  return (
    <>
      <Box
        data-testid="mis-consultorios-display"
        sx={{
          display: 'flex',
          flexDirection: 'column',
          width: '100%',
          paddingBottom: '5rem',
          minHeight: '100vh',
          alignItems: 'center',
          justifyContent: 'flex-start'
        }}>
        <Box
          sx={{
            display: 'flex',
            width: '920px',
            marginTop: 'calc(3rem + 76px)',
            marginLeft: '4rem',
            height: '100%',
            gap: '2rem',
            flexDirection: 'column'
          }}>
          <Box
            sx={{
              display: 'flex',
              gap: '0.5rem',
              flexDirection: 'column'
            }}>
            <Typography variant="h2">Mis consultorios</Typography>
            <Typography variant='bodyM'>
              En esta sección podrás ver tus consultorios y el estado de las solicitudes de conexión
              de agendas asociadas a ellos.
            </Typography>
          </Box>
          <ListadoConsultorios />
        </Box>
      </Box>
    </>
  );
}
